import { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";

/**
 * The identifiers staff paste into the Cybrid and Persona consoles all the way through
 * an investigation, so every one of them gets a copy affordance rather than asking for
 * a careful triple-click on a 32-character GUID.
 */
export function CopyValue({ value, label, empty = "—" }: { value: string | null | undefined; label: string; empty?: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  if (!value) return <>{empty}</>;
  return <span className="copy-value">
    <span className="copy-value-text">{value}</span>
    <button
      type="button"
      className={copied ? "copy-button copied" : "copy-button"}
      onClick={() => void navigator.clipboard.writeText(value).then(() => setCopied(true), () => setCopied(false))}
      aria-label={`Copy ${label}`}
    >
      {copied ? <Check size={13} aria-hidden="true" /> : <Copy size={13} aria-hidden="true" />}
      <span>{copied ? "Copied" : "Copy"}</span>
    </button>
  </span>;
}
